<ion-content class="garment-listing">
    <app-header [isParentPage]="false" [title]="'Web Order Type Admin'"></app-header>
    <div class="loading-container" style="padding-top:15%;" *ngIf="!loading">
        <ion-spinner></ion-spinner>
    </div>
  <ng-container>
    <ion-grid>
      <div class="product-table">
          <table class="custom-table">
            <thead>
              <tr>
                <th rowspan="2" style="text-align:center">Type Code</th>
                <th rowspan="2" style="width:15%">Short Name</th>
                <th rowspan="2">Description</th>
                <th rowspan="2" style="width:6%">Display Order</th>
                <th colspan="3" style="text-align:center">Email On</th>
              </tr>
              <tr>
                <th style="text-align:center">Checkout</th>
                <th style="text-align:center">Accept</th>
                <th style="text-align:center">Delivery</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let wo of woOrderTypes">
               <td> <a (click)="editWebOrderType(wo.typeCode)" class="link"> {{ wo.typeCode }} </a></td>
                <td><input type="text" [(ngModel)]="wo.shortName" class="cell-input" /></td>
                <td><input type="text" [(ngModel)]="wo.description" class="cell-input" /></td>
                <td><input type="number" [(ngModel)]="wo.displayOrder" class="cell-input" /></td>

                <td>
                  <input
                    type="checkbox"
                  [checked]="wo.emailCheckout === '1'"
                (change)="wo.emailCheckout = $event.target.checked ? '1' : '0'"
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                  [checked]="wo.emailAccept === '1'"
                   (change)="wo.emailAccept = $event.target.checked ? '1' : '0'"
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    [checked]="wo.emailDelivery === '1'"
                     (change)="wo.emailDelivery = $event.target.checked ? '1' : '0'"
                  />
                </td>
              </tr>
            </tbody>
          </table>


      </div>

      <div *ngIf="woOrderTypes?.length === 0"  style="padding-left:40%;color:red" class="alert alert-info mt-3">
        No Data found.
      </div>


            
        </ion-grid>
         <div class="form-actions" style=" float: right;padding-right: 10px;">
          <ion-button  color="gallaghergreen" class="btn-box-shadow" (click)="UpdateWebOrderType()" [disabled]="woOrderTypes?.length === 0"><span>Update</span></ion-button>
      </div>
    </ng-container>
</ion-content>
